// extracted by mini-css-extract-plugin
export var phone = "_41-0";